import React, { useState, useEffect } from 'react'; // ✅ useEffect اضافه شد
import { useNavigate } from 'react-router-dom';
import { request } from '../../services/api';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import whiteLogo from '../../images/LOGOTGN.png';
import styles from './Login.module.css';
import { Link } from 'react-router-dom'; // این رو بالا اضافه کن
import { CircuitBackgroundLayer } from "../../components/CircuitBackground/AnimatedCircuitChipBackground";

const LoginPage = ({ onLogin }) => {

  const [formData, setFormData] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // ✅ بخش جدید: چک کردن وضعیت لاگین هنگام باز شدن صفحه
  useEffect(() => {
  const savedToken = localStorage.getItem('token');
  const savedUser = localStorage.getItem('user');

  if (savedToken) {
    if (onLogin) onLogin(savedToken);

    let user = null;

    try {
      user = savedUser ? JSON.parse(savedUser) : null;
    } catch {
      user = null;
    }

    if (user?.role === 'admin') {
      navigate('/admin', { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  }
}, [navigate, onLogin]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!formData.username || !formData.password) {
      setError('لطفاً نام کاربری و رمز عبور را وارد کنید.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const data = await request('/login.php', 'POST', formData);
      if (data.status === 'success') {
        // ✅ ذخیره توکن
        localStorage.setItem('token', data.token);
        
        // ✅ اگر دیتای کاربر (مثل نام) را هم سرور می‌فرستد، ذخیره کنید
        if (data.user) {
          localStorage.setItem('user', JSON.stringify(data.user));
        }

        if (onLogin) onLogin(data.token);

if (data.user?.role === 'admin') {
  navigate('/admin');
} else {
  navigate('/');
}
      } else {
        setError(data.message || 'اطلاعات وارد شده صحیح نیست.');
      }
    } catch (err) {
      setError('خطا در برقراری ارتباط با سرور.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.parallaxSection}>
      <CircuitBackgroundLayer />
      <div className={styles.overlay}></div>
       
      <div className={styles.container}>
        <div className={styles.infoSide}>
          <img src={whiteLogo} alt="لوگو" className={styles.logo} />
          <h2 className={styles.welcomeTitle}>سیستم هوشمند گلخانه</h2>
          <p className={styles.welcomeText}>
            به پنل مدیریت یکپارچه خوش آمدید. <br/>
            برای دسترسی به سنسورها و کنترلرها وارد شوید.
          </p>
        </div>

        <div className={styles.formSide}>
          <h1 className={styles.formTitle}>ورود به حساب کاربری</h1>

          {error && <div className={styles.errorMessage}>{error}</div>}

          <form onSubmit={handleLogin} className={styles.form}>
            <div className={styles.inputGroup}>
              <label htmlFor="username" className={styles.label}>نام کاربری</label>
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                className={styles.input}
                placeholder="نام کاربری..."
                autoComplete="off"
              />
            </div>

            <div className={styles.inputGroup}>
      <label htmlFor="password" className={styles.label}>رمز عبور</label>
      <div style={{ position: 'relative' }}> {/* کانتینر برای قرارگیری آیکون */}
        <input
          type={showPassword ? "text" : "password"} // ✅ تغییر داینامیک تایپ
          id="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          className={styles.input}
          placeholder="رمز عبور ..."
          style={{ paddingLeft: '40px' }} // فضا برای آیکون در سمت چپ (اگر RTL هستید)
        />
        
        {/* ✅ آیکون چشم */}
        <div 
          onClick={() => setShowPassword(!showPassword)}
          style={{
            position: 'absolute',
            left: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            color: '#6b7280',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
        </div>
      </div>
    </div>

            <button type="submit" className={styles.loginBtn} disabled={loading}>
              {loading ? 'در حال پردازش...' : 'ورود به پنل'}
            </button>

            <div style={{ textAlign: 'center', marginTop: '15px', fontSize: '13px', color: '#6b7280' }}>
              <span>رمز عبور خود را فراموش کرده‌اید؟    
                <Link to="/forgot-password" className={styles.forgotLink}>
                  فراموشی رمز عبور     
                </Link>
              </span>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;